import ProjectSubmissionForm from "../Seekar_form";

const UpdateSeekarform = () => {
  return (
    <>
      <ProjectSubmissionForm title="Update Your Project" buttontitle="Update" />
       
    </>
  );
};

export default UpdateSeekarform;